import { render, staticRenderFns } from "./CustomersBriefcaseTable.vue?vue&type=template&id=07031fa6&scoped=true&"
import script from "./CustomersBriefcaseTable.vue?vue&type=script&lang=js&"
export * from "./CustomersBriefcaseTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomersBriefcaseTable.vue?vue&type=style&index=0&id=07031fa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07031fa6",
  null
  
)

export default component.exports